import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, errorText, setToken } from "@/lib/api";
import { ROLES } from "@/lib/roles";
import { Field, Loading, PrimaryButton, errorCls, inputCls } from "@/components/agent/ui";
import { LogoMark } from "@/components/agent/AgentLayout";

export default function Join() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [loadError, setLoadError] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/public/invite/${token}`).then((r) => setInvite(r.data)).catch((err) => setLoadError(errorText(err)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(`/public/invite/${token}`, { name: name.trim(), password });
      setToken(data.token);
      navigate("/", { replace: true });
    } catch (err) {
      setError(errorText(err, "Please check your details and try again."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="flex w-full max-w-sm flex-col gap-6" data-testid="join-page">
        <div className="flex flex-col items-center gap-3 text-center">
          <LogoMark className="size-10 rounded-xl text-lg" />
          <div>
            <h1 className="text-xl font-semibold" data-testid="join-title">{invite ? `Join ${invite.org_name}` : "Join your team on Landin"}</h1>
            {invite && <p className="text-sm text-muted-foreground">You're invited as {ROLES[invite.role]?.label.toLowerCase()}. Choose how you'll sign in.</p>}
          </div>
        </div>
        {loadError ? (
          <p className="rounded-xl bg-destructive/10 p-4 text-center text-sm text-destructive" data-testid="join-error">{loadError}</p>
        ) : !invite ? <Loading /> : (
          <form onSubmit={submit} className="flex flex-col gap-4" data-testid="join-form">
            <Field label="Email"><input value={invite.email} disabled className={inputCls} data-testid="join-email" /></Field>
            <Field label="Your name"><input required autoFocus maxLength={120} value={name} onChange={(e) => setName(e.target.value)} className={inputCls} data-testid="join-name" /></Field>
            <Field label="Password" help="At least 8 characters.">
              <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" className={inputCls} data-testid="join-password" />
            </Field>
            {error && <p className={`${errorCls} text-center`} data-testid="join-submit-error">{error}</p>}
            <PrimaryButton type="submit" size="lg" isLoading={busy} testid="join-submit">Join and sign in</PrimaryButton>
          </form>
        )}
      </div>
    </div>
  );
}
